<template>
  <div>
    <h3 class="has-text-centered is-size-5">כל השיעורים</h3>
    <div class="columns">
      <div class="column is-3">
        <button class="button" @click="openModal">סינון לפי מורים</button>
      </div>
      <div class="column">
        <input
          type="text"
          class="input"
          placeholder="סינון לפי מילות מפתח"
          v-model="term"
          @keyup="searchTerm"
          v-if="teachers.length === 0"
        />
        <div v-else>
          <fade-transition :group="true">
            <teacher-tag
              v-for="teacher in teachers"
              :key="teacher"
              :teacher="teacher"
            ></teacher-tag>
          </fade-transition>
        </div>
      </div>
    </div>

    <div class="all-videos">
      <zoom-x-transition :group="true" tag="div">
        <video-item-add
          v-for="video in videoList"
          :key="video.id"
          :item="video"
        ></video-item-add>
      </zoom-x-transition>
    </div>
    <div
      class="has-text-centered"
      v-if="term.length < 1 && teachers.length === 0"
    >
      <button class="button is-info" @click="loadMore">טען עוד &plus;</button>
    </div>
  </div>
</template>

<script>
import VideoItemAdd from "@/components/videoItemAdd.vue";
import TeacherTag from "@/components/teacherTag.vue";
import { ZoomXTransition } from "vue2-transitions";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    VideoItemAdd,
    TeacherTag,
    ZoomXTransition,
    FadeTransition
  },
  data() {
    return {
      term: "",
      videoList: [],
      page: 1,
      toShow: 50,
      sorting: false
    };
  },
  computed: {
    all() {
      return this.$store.state.videos;
    },
    teachers() {
      return this.$store.state.teacherSort;
    }
  },
  methods: {
    loadMore() {
      this.page = this.page + 1;
      this.videoList = this.all.slice(0, this.toShow * this.page);
    },
    searchTerm() {
      let arr = [];

      if (!this.sorting) {
        if (this.term.length > 1) {
          this.sorting = true;
          this.all.forEach(video => {
            if (video.pagetitle.includes(this.term)) {
              arr.push(video);
            }
          });
          this.videoList = arr;
        } else {
          this.videoList = this.all.slice(0, this.toShow);
        }
        this.sorting = false;
      }
    },
    openModal() {
      this.$store.dispatch("toggleTeachersModal", true);
    }
  },
  watch: {
    all() {
      if (this.all.length > 0) {
        this.videoList = this.all.slice(0, this.toShow);
      }
    },
    teachers() {
      let output = [];
      if (this.teachers.length > 0) {
        // sort by teachers
        this.all.forEach(video => {
          if (this.teachers.includes(video.videoTeacher)) {
            output.push(video);
          }
        });
        this.videoList = output;
      } else {
        this.videoList = this.all.slice(0, this.toShow);
      }
    }
  },
  mounted() {
    this.videoList = this.all.slice(0, this.toShow);
  }
};
</script>

<style lang="scss">
.all-videos > div {
  display: flex;
  flex-wrap: wrap;
}
</style>
